"use client";

import { usePathname } from "next/navigation";
import posthog from "posthog-js";
import { useEffect } from "react";
import { GlobalErrorDisplay } from "./_components/GlobalErrorDisplay";
import { getLangFromPathname } from "./_utils/get-lang-from-pathname";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  const pathname = usePathname();
  const lang = getLangFromPathname(pathname) ?? "en";

  return (
    <div>
      <GlobalErrorDisplay lang={lang} reset={reset} />
    </div>
  );
}
